<template>
  <div :class="wrapperClass">
    <textarea
      ref="input"
      v-bind="$attrs"
      :placeholder="placeholder"
      :value="value"
      :readonly="readonly"
      class="w-full h-full bg-transparent outline-none resize-none px-4 py-2"
      style="min-height:200px;"
      @input="onInput"
      @keyup="keyup"
      @keydown="keydown"
    ></textarea>
  </div>
</template>

<script>
import { twJoin } from 'tailwind-merge';

export default {
  name: 'EmbedArea',
  props: {
    value: {},
    variant: { type: String, default: 'dark' },
    placeholder: { type: String, default: '' },
    readonly: { type: Boolean, default: false }
  },
  computed: {
    wrapperClass() {
      const baseClass =
        'w-full h-full relative border rounded-lg overflow-hidden';
      const variantClass = {
        base: 'bg-white text-dark border-grey-200',
        dark: 'bg-secondary text-secondary-invert border-secondary-lighter'
      };
      return twJoin(baseClass, variantClass[this.variant]);
    }
  },
  methods: {
    onInput() {
      this.$emit(
        'input',
        this.$refs.input.value.replace(/\\([\s\S])|("|\/)/gi, '\\$1$2')
      );
    },
    keyup() {
      this.$emit(
        'input',
        this.$refs.input.value.replace(/\\([\s\S])|("|\/)/gi, '\\$1$2')
      );
      this.$emit(
        'keyup',
        this.$refs.input.value.replace(/\\([\s\S])|("|\/)/gi, '\\$1$2')
      );
    },
    keydown(e) {
      this.$emit('keydown', e);
    }
  }
};
</script>
